import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import select2 from 'select2';
// eslint-disable-next-line no-unused-vars
import DataTable from 'datatables';

export default {
	init() {
		let table = $('#myTable');
		table.find('tfoot th').each(function () {
			var title = $(this).text();
			if (title.length > 0) {
				$(this).html('<input type="text" class="border border-grey-darkest py-3 px-4 w-full max-w-full" placeholder="Sök ' + title + '" />');
			}
		});

		const getInfluencersFiltered = () => {
			$.ajax({
				type: 'POST',
				dataType: 'json',
				url: window.ajax_object.ajaxurl,
				data: {
					action: 'get_influencers_filter',
					nonce: window.ajax_object.nonce,
				},
				success: (response) => {
					$('#influencers-table').empty();
					$('#influencers-table').append(response);
					table = table.DataTable({
						language: {
							info: 'Visar _START_ till _END_ av totalt _TOTAL_ rader',
							infoEmpty: 'Visar 0 till 0 av totalt 0 rader',
							infoFiltered: '',
							lengthMenu: 'Visa _MENU_ rader',
							infoThousands: ' ',
							zeroRecords: 'Hittade inga matchande resultat',
							search: 'Sök:',
							paginate: {
								first: 'Första',
								last: 'Sista',
								next: 'Nästa',
								previous: 'Föregående',
							},
						},
						initComplete: function () {
							this.api()
								.columns()
								.every(function () {
									var that = this;

									$('input', this.footer()).on(
										'keyup change clear',
										function () {
											if (that.search() !== this.value) {
												that.search(this.value).draw();
											}
										}
									);
								});
						},
					});
				},
			});
		};

		$('#influencer-macro-filter').on('change', (e) => {
			table
				.column(2)
				.search(e.target.value === 'all' ? '' : e.target.value)
				.draw();
		});

		getInfluencersFiltered();
	},
};
